'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueRemove = exports.MultiValueLabel = exports.MultiValueContainer = exports.MultiValueGeneric = exports.multiValueRemoveCSS = exports.multiValueLabelCSS = exports.multiValueCSS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emotion = require('emotion');

var _indicators = require('./indicators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const multiValueCSS = exports.multiValueCSS = ({
  theme: { spacing, borderRadius, colors }
}) => ({
  backgroundColor: colors.neutral10,
  borderRadius: borderRadius / 2,
  display: 'flex',
  margin: spacing.baseUnit / 2,
  minWidth: 0 // resolves flex/text-overflow bug
});

const multiValueLabelCSS = exports.multiValueLabelCSS = ({ theme: { borderRadius, colors }, cropWithEllipsis }) => ({
  borderRadius: borderRadius / 2,
  color: colors.neutral80,
  fontSize: '85%',
  overflow: 'hidden',
  padding: 3,
  paddingLeft: 6,
  textOverflow: cropWithEllipsis ? 'ellipsis' : null,
  whiteSpace: 'nowrap'
});

const multiValueRemoveCSS = exports.multiValueRemoveCSS = ({
  theme: { spacing, borderRadius, colors },
  isFocused
}) => ({
  alignItems: 'center',
  borderRadius: borderRadius / 2,
  backgroundColor: isFocused && colors.dangerLight,
  display: 'flex',
  paddingLeft: spacing.baseUnit,
  paddingRight: spacing.baseUnit,
  ':hover': {
    backgroundColor: colors.dangerLight,
    color: colors.danger
  }
});

const MultiValueGeneric = exports.MultiValueGeneric = ({
  children,
  innerProps
}) => _react2.default.createElement(
  'div',
  innerProps,
  children
);

const MultiValueContainer = exports.MultiValueContainer = MultiValueGeneric;
const MultiValueLabel = exports.MultiValueLabel = MultiValueGeneric;
class MultiValueRemove extends _react.Component {
  render() {
    const { children, innerProps } = this.props;
    return _react2.default.createElement(
      'div',
      innerProps,
      children
    );
  }
}

exports.MultiValueRemove = MultiValueRemove;
MultiValueRemove.defaultProps = {
  children: _react2.default.createElement(_indicators.CrossIcon, { size: 14 })
};
class MultiValue extends _react.Component {
  render() {
    const {
      children,
      className,
      components,
      cx,
      data,
      getStyles,
      innerProps,
      isDisabled,
      removeProps,
      selectProps
    } = this.props;

    const { Container, Label, Remove } = components;

    const containerInnerProps = _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValue', this.props)), {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
      }, className)
    }, innerProps);

    const labelInnerProps = {
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueLabel', this.props)), {
        'multi-value__label': true
      }, className)
    };

    const removeInnerProps = _extends({
      className: cx( /*#__PURE__*/(0, _emotion.css)(getStyles('multiValueRemove', this.props)), {
        'multi-value__remove': true
      }, className)
    }, removeProps);

    return _react2.default.createElement(
      Container,
      {
        data: data,
        innerProps: containerInnerProps,
        selectProps: selectProps
      },
      _react2.default.createElement(
        Label,
        {
          data: data,
          innerProps: labelInnerProps,
          selectProps: selectProps
        },
        children
      ),
      _react2.default.createElement(Remove, {
        data: data,
        innerProps: removeInnerProps,
        selectProps: selectProps
      })
    );
  }
}

MultiValue.defaultProps = {
  cropWithEllipsis: true
};
exports.default = MultiValue;